import { useEffect, useRef } from 'react';
import TagManager from 'react-gtm-module';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router';
import useLocalStorageState from 'use-local-storage-state';
import useSessionStorageState from 'use-session-storage-state';

import FlotiqPlugins from '../../lib/flotiq-plugins/flotiqPluginsRegistry';
import { resetGtmDataLayer } from '../../lib/helpers';

const Logout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toastRef = useRef<string>('');
  const [searchParams] = useSearchParams();
  const logoutReason = searchParams.get('reason');

  const [, , { removeItem }] = useLocalStorageState('cms.user');
  const [, , { removeItem: removeImpersonation }] =
    useSessionStorageState('cms.impersonate');

  useEffect(() => {
    if (toastRef.current) {
      toast.remove(toastRef.current);
    }
    if (logoutReason === 'auth-error') {
      toastRef.current = toast.error(t('Global.UserNotAuthenticated'));
    } else if (logoutReason === 'new-system-version') {
      toastRef.current = toast.error(t('Global.UserWasLogoutNewSystemVersion'));
    }
  }, [logoutReason, t]);

  const logoutSentRef = useRef<boolean>(false);

  useEffect(() => {
    if (!logoutSentRef.current) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'logout',
        },
      });
      logoutSentRef.current = true;
    }

    removeImpersonation();
    removeItem();
    resetGtmDataLayer();

    navigate('/login');

    if (FlotiqPlugins.getLoadedPluginsIds().length) window.location.reload();
  }, [navigate, removeItem, removeImpersonation]);

  return <></>;
};

export default Logout;
